export const name = 'viewerManagerRendererModelApi' as const
